import React, { useEffect, useState } from "react"

// libraries
import Skeleton from "react-loading-skeleton"

// helpers
import Api from "@/_helpers/Api"

// providers
import { trans } from "@/_providers/Translation"
import { getColorVariationFromPrimaryColorBasedOnIndex } from "@/_helpers/calculateColor"

function getCategoriesFromApi(apiChartData) {
  if (!apiChartData) return []

  const labels = Array.isArray(apiChartData.labels) ? apiChartData.labels : []
  const values = Array.isArray(apiChartData.reservations)
    ? apiChartData.reservations
    : []
  const percentages = Array.isArray(apiChartData.percentages)
    ? apiChartData.percentages
    : []
  const revenues = Array.isArray(apiChartData.revenues)
    ? apiChartData.revenues
    : []

  return labels.map((label, idx) => ({
    label,
    value: values[idx] || 0,
    percentage: percentages[idx] || 0,
    revenue: revenues[idx] || 0,
  }))
}

function TopClients() {
  const [loading, setLoading] = useState(true)
  const [apiData, setApiData] = useState(null)

  useEffect(() => {
    Api.get("analytics/top-revenue-clients")
      .then((res) => {
        if (res.data) setApiData(res.data)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [])

  return (
    <div className="clients-by-category-chart">
      <div className="head">
        <h3>{trans("analytics.topClients")}</h3>
      </div>
      <hr />
      {loading ? (
        <Skeleton height={300} count={1} />
      ) : (
        <div className="cbc-list-wrapper">
          {getCategoriesFromApi(apiData?.chart_data).map((cat, idx, arr) => (
            <div className="cbc-row" key={cat.label}>
              <div className="cbc-row-head">
                <span className="cbc-label">{cat.label}</span>
                <span className="cbc-value">
                  {`${trans("analytics.reservationsLabel")}: ${cat.value}`}
                  <i
                    style={{ color: "#35B084" }}
                  >{`(${cat.revenue.toFixed(2)} ${apiData?.currency.name })`}</i>
                </span>
              </div>
              <div className="cbc-bar-bg">
                <div
                  className="cbc-bar"
                  style={{
                    background:
                      getColorVariationFromPrimaryColorBasedOnIndex(idx),
                    width: `${(cat.value / Math.max(...arr.map((c) => c.value), 1)) * 100}%`,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default TopClients
